import { Component, Input, Output, EventEmitter} from '@angular/core';


import { Producto } from 'src/app/_models';


@Component({
    selector: 'app-producto',
    templateUrl: 'producto.component.html'})
export class ProductoComponent  {

    constructor() {}

    @Input()
    producto: Producto;

    // @Input()
    // monetizada: Boolean;

    @Output() 
    addProductoEvent: EventEmitter<Producto> = new EventEmitter();

    add() {
        this.addProductoEvent.emit(this.producto);
    }
    
}